export type EasyPlanHomeInfo = {
  easyPlan: {
    about: PageInfo;
    cost: PageInfo;
    perks: PageInfo;
    welcome: PageInfo;
  };
};

export type PageInfo = {
  title: string;
  description: string;
  footerDescription?: string;
  breakdown?: BreakDown;
  tileList?: Array<TitleList>;
};

export type BreakDown = {
  title: string;
  types: Array<BreakTypes>;
};

export type BreakTypes = {
  title: string;
  charges: string;
};

export type LevelTypes = {
  title: string;
  charges: string;
};

export type TitleList = {
  title: string;
  subtitle: string;
  image?: string;
  order?: number;
  link?: string;
};

export enum EASY_PLAN_API_TYPE {
  EASY_PLAN_HOME = 'easyplanhome',
  WELCOME = 'welcome',
  COST = 'cost',
  PERKS = 'perks',
  ABOUT = 'about',
}
